import i18n from '@/i18n';
import './assets/main.css';
import 'vite/modulepreload-polyfill';
import { createApp } from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { vAutoAnimate } from '@formkit/auto-animate';
import MegaMenuMobilePartial from '@/partials/MegaMenuPartial/MegaMenuMobilePartial.vue';
import { createPinia } from 'pinia';

library.add(fas, fab, far);

createApp(MegaMenuMobilePartial)
  .use(i18n)
  .use(createPinia())
  .component('font-awesome-icon', FontAwesomeIcon)
  .directive('auto-animate', vAutoAnimate)
  .mount('#mega-menu-mobile-partial');
